var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useMemo, useState } from "react";
import { Input } from "@mui/joy";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
export var isHTML = function (str) {
    var pattern = /<\/?[a-z][\s\S]*>/i;
    return pattern.test(str);
};
/** <b>Composant d'affichage en mode édition d'un champ de type base</b>*/
export default function BaseFieldEdit(_a) {
    var fieldName = _a.fieldName, record = _a.record, onUpdate = _a.onUpdate, fieldClassName = _a.fieldClassName, componentClassName = _a.componentClassName, fieldMetadata = _a.fieldMetadata, isReport = _a.isReport;
    var fieldMetadataValue = fieldMetadata && (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.type) === "iframe"
        ? (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default)
            ? fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default
            : "http://"
        : fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default;
    var defaultValue = useMemo(function () {
        if (!record) {
            return "";
        }
        return isReport
            ? record.value
            : record[fieldName || ""] || (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.default);
    }, [fieldName, record]);
    var _b = useState(""), value = _b[0], setValue = _b[1];
    useEffect(function () {
        setValue(defaultValue || "");
    }, [defaultValue]);
    var valueIframe = (fieldMetadata === null || fieldMetadata === void 0 ? void 0 : fieldMetadata.type) === "iframe" ? value || "http://" : value;
    var _c = useState(valueIframe), defaultIframeValue = _c[0], setDefaultIframeValue = _c[1];
    return (_jsx("div", __assign({ className: "flex-1 ".concat(fieldClassName ? fieldClassName : "") }, { children: isHTML(value) ? (_jsx(ReactQuill, { value: value, onChange: function (value) {
                var _a;
                setValue(value);
                if (onUpdate) {
                    onUpdate((_a = {}, _a[fieldName] = value, _a));
                }
            } })) : (_jsx(Input, { type: "text", autoFocus: true, value: value || defaultIframeValue, size: "sm", className: "w-full ".concat(componentClassName ? componentClassName : "text-left "), onChange: function (event) {
                var _a;
                var newValue = event.target.value;
                setDefaultIframeValue(newValue);
                setValue(newValue);
                if (onUpdate) {
                    onUpdate((_a = {}, _a[fieldName] = newValue, _a));
                }
            } })) })));
}
